"use strict"; 
(function () { 
  if (!customElements.get("product-fc-slider")) { 
    class AnnouncementBar extends HTMLElement { 
      constructor() { 
        super(); 
        this.swiper = null; 
        this.slider = this.querySelector(".swiper"); 
      } 
      
      connectedCallback() { 
        this.initSwiper(); 
      } 
    } 

    AnnouncementBar.prototype.initSwiper = function () { 
      if (!this.slider) return; 
      
      const speed = Number(this.slider.dataset.speed) || 500; 
      const changeSpeed = Number(this.slider.dataset.changeSpeed) || 5000; 
      const rotate = this.slider.dataset.rotate === "true"; 
      const fractionPagination = this.querySelector(".swiper-pagination-fraction"); 
      const bulletsPagination = this.querySelector(".swiper-pagination-bullets"); 
      
      const playAllVideos = () => {
        const allVideos = this.querySelectorAll("video");
        allVideos.forEach(video => {
          video.loop = true;
          video.muted = true;
          video.play().catch(err => console.log("Play blocked:", err));
        });
      };
      
      const swiperOptions = { 
        loop: true, 
        slidesPerView: 1.1, 
        spaceBetween: 8, 
        grabCursor: true, 
        longSwipesRatio: 0.3, 
        fadeEffect: { 
          crossFade: true, 
        }, 
        speed, 
        pagination: { 
          el: ".swiper-pagination-fraction", 
          type: "fraction", 
          renderFraction: function (currentClass, totalClass) { 
            return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`; 
          }, 
          formatFractionCurrent: function (number) { 
            return number < 10 ? "0" + number : number; 
          }, 
          formatFractionTotal: function (number) { 
            return number < 10 ? "0" + number : number; 
          }, 
        }, 
        on: { 
          init: function () {
            setTimeout(playAllVideos, 500);
          },
          slideChangeTransitionEnd: function() {
            playAllVideos();
          }
        }, 
        breakpoints: { 
          767: { 
            slidesPerView: 2, 
            spaceBetween: 30, 
          }, 
          1025: { 
            slidesPerView: 3, 
          }, 
          1200: { 
            slidesPerView: 4, 
          }, 
        }, 
      }; 
      
      if (rotate) { 
        swiperOptions.autoplay = { 
          delay: changeSpeed, 
          disableOnInteraction: false,
        }; 
      } 
      
      this.swiper = new Swiper(this.slider, swiperOptions); 
      
      this.querySelectorAll("video").forEach(video => {
        video.addEventListener("pause", function() {
          this.play().catch(err => console.log("Play error:", err));
        });
      });
      
      if (bulletsPagination) { 
        setTimeout(() => { 
          const originalSlides = this.querySelector(".swiper-wrapper").querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)"); 
          const totalSlides = originalSlides.length; 
          bulletsPagination.innerHTML = ""; 
          
          for (let i = 0; i < totalSlides; i++) { 
            const bullet = document.createElement("span"); 
            bullet.className = "swiper-pagination-bullet"; 
            
            if (i === this.swiper.realIndex) { 
              bullet.classList.add("swiper-pagination-bullet-active"); 
            } 
            
            bullet.addEventListener("click", () => { 
              this.swiper.slideToLoop(i); 
            }); 
            
            bulletsPagination.appendChild(bullet); 
          } 
          
          this.swiper.on("slideChange", () => { 
            const bullets = bulletsPagination.querySelectorAll(".swiper-pagination-bullet"); 
            const realIndex = this.swiper.realIndex; 
            
            bullets.forEach((bullet, index) => { 
              if (index === realIndex) { 
                bullet.classList.add("swiper-pagination-bullet-active"); 
              } else { 
                bullet.classList.remove("swiper-pagination-bullet-active"); 
              } 
            }); 
          }); 
        }, 100); 
      } 
    }; 
    
    customElements.define("product-fc-slider", AnnouncementBar); 
  } 
})();